<div *ngIf="isShowingRouteLoadIndicator && userLoggedIn" class="router-load-spinner-overlay">
  <i class="fa fa-circle-o-notch fa-spin"></i>
</div>

<div
    class="d-flex row no-gutters flex-fill"
    (contextmenu)="onRightClick($event)">
  <acs-primary-nav-v class="d-flex flex-column" *ngIf="showMenu"></acs-primary-nav-v>

  <div id="content-column" class="d-flex flex-column col">
    <mat-toolbar class="md-toolbar-tools header-toolbar">
      <button mat-icon-button (click)="toggleMenu()" *ngIf="userLoggedIn" class="toolbar-secondary-button">
        <fa-icon [icon]="toggleMenuIcon" aria-label="Change Menu"></fa-icon>
      </button>

      <button mat-button (click)="toggleWindowPin()"
              *ngIf="userLoggedIn"
              class="toolbar-secondary-button"
              [color]="pinColor"
              aria-label="Pin Window">
        <fa-icon [icon]="thumbTackIcon"></fa-icon>
      </button>

      <div id="pageTitle" class="row no-gutters"><span>{{ title }}</span></div>

      <button mat-button (click)="openInNewWindow()"
              *ngIf="userLoggedIn"
              class="toolbar-secondary-button"
              aria-label="Open the current page in a new window">
        <mat-icon fontIcon="fa-external-link" class="fa"></mat-icon>
      </button>

      <acs-toolbar class="ml-auto"></acs-toolbar>
    </mat-toolbar>

    <div id="content" class="page-content" class="d-flex flex-column flex-fill">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
